import React, { useState, useEffect } from 'react';
import OperationsUserPage from './OperationsUserPage';
import UserPage from './UserPage';
import { useRerunAnalysisMutation } from '../endpoints/synthesis';
import { Modal, Button, Text, Group } from '@mantine/core';

const OperationsManager = () => {
  const [isUserPageOpen, setIsUserPageOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(undefined);
  const [sourceDatas, setSourceDatas] = useState([]);
  const [
    analyze,
    {
      isLoading: isAnalysisFetching,
      isError: analysisError,
      isSuccess: successfulAnalysis,
    },
  ] = useRerunAnalysisMutation();
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showResponseError, setShowResponseError] = useState(false);
  const [showAnalyzing, setShowAnalyzing] = useState(false);
  const [showResponseValid, setShowResponseValid] = useState(false);
  const [showResponseNoSources, setShowResponseNoSources] = useState(false);

  useEffect(() => {
    setShowConfirmationModal(false);
    if (analysisError) {
      setShowResponseError(true);
      setShowAnalyzing(false);
    } else if (successfulAnalysis) {
      setShowResponseValid(true);
      setShowAnalyzing(false);
    }
  }, [isAnalysisFetching, successfulAnalysis, analysisError]);

  const updatePage = (user) => {
    setSelectedUser(user);
    setIsUserPageOpen(true);
  };

  const updateSourceData = (sourceData) => {
    if (sourceDatas.includes(sourceData)) {
      setSourceDatas(sourceDatas.filter((item) => item !== sourceData));
    } else {
      setSourceDatas([...sourceDatas, sourceData]);
    }
  };

  const handleRerunAnalysis = () => {
    if (sourceDatas.length == 0) {
      setShowResponseNoSources(true);
      return;
    } else {
      setShowResponseNoSources(false);
    }
    setShowConfirmationModal(true);
    setShowResponseError(false);
    setShowResponseValid(false);
  };
  const confirmRerunAnalysis = () => {
    setShowAnalyzing(true);
    analyze({
      sourcedatas: sourceDatas.map((item) => item.id),
      user: selectedUser,
    });
  };
  return (
    <div>
      {!isUserPageOpen && <OperationsUserPage updatePage={updatePage} />}
      {isUserPageOpen && (
        <UserPage
          selectedUser={selectedUser}
          setIsUserPageOpen={(val) => setIsUserPageOpen(val)}
          updateSourceData={(sourcedata) => updateSourceData(sourcedata)}
          rerunAnalysis={() => handleRerunAnalysis()}
          showResponseError={showResponseError}
          showResponseValid={showResponseValid}
          showResponseNoSources={showResponseNoSources}
          showAnalyzing={showAnalyzing}
        />
      )}
      <Modal
        opened={showConfirmationModal}
        onClose={close}
        title="Confirm Analysis"
        withCloseButton={false}
      >
        <Text mb={5}>
          {' '}
          Are you sure you want to analyze these source datas for{' '}
          {selectedUser?.username}?
        </Text>
        {sourceDatas.map((sourceData) => (
          <Text key={sourceData.id} size="xs" fw={500}>
            - {sourceData.s3_path}
          </Text>
        ))}

        {!showAnalyzing && (
          <Group justify="space-between" mt={5}>
            <Button onClick={() => setShowConfirmationModal(false)} color="red">
              No
            </Button>
            <Button onClick={confirmRerunAnalysis} color="blue">
              Yes
            </Button>
          </Group>
        )}
      </Modal>
    </div>
  );
};

export default OperationsManager;
